import React from "react";
import { observer } from "mobx-react";
import useRotatingMessages from "Components/common/hooks/useRotatingMessages";

const ProgressBlock = observer(({ block }) => {
  const running = block.status === "running";
  const rotatingMessage = useRotatingMessages(
    block.messages || [],
    running,
    1800
  );

  // Completed work collapses to one muted line so past steps don't hold the
  // same visual weight as live content.
  if (!running) {
    return (
      <div className={`copilotProgress copilotProgress--${block.status}`}>
        <div className="copilotProgress__head">
          <i className="material-icons-outlined copilotProgress__statusIcon">
            {block.status === "done" ? "check_circle" : "error_outline"}
          </i>
          <span className="copilotProgress__label">{block.label}</span>
          {block.detail && (
            <span className="copilotProgress__detailInline">
              · {block.detail}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="copilotProgress copilotProgress--running">
      <div className="copilotProgress__head">
        <span className="copilotProgress__spinner" />
        <span className="copilotProgress__label">
          {rotatingMessage || block.label}
        </span>
        {typeof block.percent === "number" && (
          <span className="copilotProgress__percent">{block.percent}%</span>
        )}
      </div>
      {typeof block.percent === "number" && (
        <div className="copilotProgress__bar">
          {/* width via decile classes: inline styles are disallowed */}
          <div
            className={`copilotProgress__barFill fill-${Math.min(
              100,
              Math.max(0, Math.round(block.percent / 10) * 10)
            )}`}
          />
        </div>
      )}
    </div>
  );
});

export default ProgressBlock;
